import { render, staticRenderFns } from "./OrderElement.vue?vue&type=template&id=797e1074"
import script from "./OrderElement.vue?vue&type=script&lang=js"
export * from "./OrderElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports